import { GamePhase } from '../entities/GamePhase';
import { ChangeGamePhaseEvent } from '../events/changeGamePhase/ChangeGamePhaseEvent';
import { DrawCleavageEvent } from '../events/drawCleavage/DrawCleavageEvent';
import { UseCase } from './UseCase';
export class VideoExtractStopUseCase extends UseCase {
    constructor(applicationServices) {
        super();
        this.applicationServices = applicationServices;
    }
    execute(event) {
        return Promise.all([
            this.applicationServices.videoExtract.removeVideoExtractOnInterface()
        ])
            .then(() => this.applicationServices.autoplay.hasAutoplay())
            .then(hasAutoplay => this.applicationServices.event.sentEvents([
            new ChangeGamePhaseEvent(GamePhase.NEW_CLEAVAGE),
            ...hasAutoplay ? [new DrawCleavageEvent()] : []
        ]));
    }
}
